import { createSelector } from "reselect";

function sortEvents(a, b) {
  const aPO = a.purchaseOrder || a.inventoryPurchaseOrder;
  const bPO = b.purchaseOrder || b.inventoryPurchaseOrder;

  if (aPO && bPO) {
    return aPO.deliveryOrder - bPO.deliveryOrder || aPO.id - bPO.id;
  } else if (aPO) {
    return -1;
  } else if (bPO) {
    return 1;
  } else {
    return a.displayOrder - b.displayOrder || a.id - b.id;
  }
}

const sortedEvents = createSelector(
  (state) => state.events.events,
  (events) => events.sort(sortEvents)
);

const showBids = createSelector(
  (state) => state.calendar.showBids,
  (state) => state.settings.entity,
  (showBids, entity) => showBids || entity === "bids"
);

const showDeliveries = createSelector(
  (state) => state.calendar.showDeliveries,
  (state) => state.settings.entity,
  (showDeliveries, entity) => showDeliveries || entity === "purchaseOrders"
);

const showJobs = createSelector(
  (state) => state.calendar.showJobs,
  (state) => state.settings.entity,
  (showJobs, entity) => showJobs || entity === "jobs"
);

export const visibleEventsSelector = createSelector(
  sortedEvents,
  showBids,
  showDeliveries,
  showJobs,
  (events, showBids, showDeliveries, showJobs) =>
    events.filter(
      (e) =>
        (showJobs && !!e.job) ||
        (showDeliveries && (!!e.purchaseOrder || !!e.inventoryPurchaseOrder)) ||
        (showBids && !!e.bid) ||
        !!e.datasheet ||
        !!e.customer ||
        e.appttype != "" ||
        e.description != "" ||
        e.evttype === "appointments"
    )
);

export const assignedEventsSelector = createSelector(
  visibleEventsSelector,
  (events) => events.filter((e) => !!e.crew)
);

export const unassignedEventsSelector = createSelector(
  visibleEventsSelector,
  (events) => events.filter((e) => !e.crew)
);
export const assignedEventsWithEquipmentSelector = createSelector(
  visibleEventsSelector,
  (events) => events.filter((e) => !!e.crew.equipment)
);

export const unassignedEventsWithEquipmentSelector = createSelector(
  visibleEventsSelector,
  (events) => events.filter((e) => !e.crew).equipment
);
